import { render } from "./InfoJurusan.vue?vue&type=template&id=7a521248&scoped=true"
import script from "./InfoJurusan.vue?vue&type=script&lang=js"
export * from "./InfoJurusan.vue?vue&type=script&lang=js"

import "./InfoJurusan.vue?vue&type=style&index=0&id=7a521248&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a521248"]])

export default __exports__